module.exports = __webpack_public_path__ + "img/1F619.6a17a881.svg";